// Messages programmés (30 oct. 2026) : la carte de l'annonce avec les messages envoyés
// automatiquement à chaque réservation. Panneau : components/Propiedades/ScheduledMessagesPanel.vue
export const scheduledMessages = {
  head: {
    title: "Messages programmés",
    sub: "Ce que reçoit le voyageur, de la réservation jusqu'après son départ.",
    new: "Nouveau message",
  },
  loadError: "Impossible de charger les messages.",
  retry: "Réessayer",
  cancel: "Annuler",
  noName: "Sans nom",
  tabs: { mensajes: "Messages", proximos: "Prochains envois", historial: "Historique" },
  stages: { antes: "Avant l'arrivée", durante: "Pendant le séjour", despues: "Après le départ" },
  when: {
    entrada: "check-in",
    salida: "check-out",
    sameDay: "Le jour du {momento}, à {hora}",
    before: "{n} jour avant le {momento}, à {hora} | {n} jours avant le {momento}, à {hora}",
    after: "{n} jour après le {momento}, à {hora} | {n} jours après le {momento}, à {hora}",
  },
  channels: { email: "E-mail", whatsapp: "WhatsApp", ota: "OTA" },
  origins: { all: "Toutes", directa: "Directes", booking: "Booking", airbnb: "Airbnb", expedia: "Expedia", otras: "Autres canaux" },
  status: {
    pendiente: "En cours",
    enviado: "Envoyé",
    en_cola: "En attente d'acceptation",
    fallo: "Non envoyé",
    sin_contacto: "Sans coordonnées",
    cancelado: "Annulé",
  },
  errors: {
    canal_reserva_no_encontrada: "Le canal n'a pas trouvé cette réservation. Elle n'existe peut-être plus ou son chat n'est pas disponible.",
    canal_sin_permiso: "Le canal n'a pas autorisé l'envoi. Vérifiez la connexion de cet hébergement.",
    canal_no_responde: "Le canal n'a pas répondu à ce moment-là.",
    canal_rechazo: "Le canal n'a pas accepté le message.",
    whatsapp_numero_invalido: "Le numéro n'est pas valide ou n'a pas WhatsApp.",
    whatsapp_rechazo: "WhatsApp n'a pas accepté le message.",
    correo_fallido: "L'e-mail n'a pas pu être remis.",
    envio_fallido: "L'envoi n'a pas pu aboutir.",
    envio_interrumpido: "L'envoi a été interrompu avant la fin.",
    sin_telefono: "La réservation n'a pas de téléphone valide.",
    sin_correo: "La réservation n'a pas d'e-mail propre. Celui des OTA est un alias.",
    sin_chat_ota: "La réservation ne provient pas d'une OTA avec chat.",
    mensaje_borrado: "Le message a été supprimé avant l'envoi.",
    mensaje_desactivado: "Le message a été désactivé avant l'envoi.",
    reserva_cancelada: "La réservation a été annulée avant l'envoi.",
    alojamiento_no_existe: "L'hébergement n'existe plus.",
    mensaje_vacio: "Le message est vide.",
    ya_no_tocaba: "Quand le voyageur a accepté, il n'y avait plus lieu de le remettre.",
  },
  unitScope: {
    sub: "Uniquement pour {name}. Les messages de l'annonce lui parviennent aussi, sauf si vous les modifiez ou les désactivez ici.",
    inherited: "De l'annonce",
    replaces: "Remplace celui de l'annonce",
    removed: "Désactivé pour cette unité",
    offInListing: "Désactivé dans l'annonce",
    differentIn: "Différent pour : {names}",
    customize: "Modifier pour cette unité uniquement",
    turnOff: "Ne pas envoyer « {name} » pour cette unité",
    confirmRestore: "Supprimer ? Le message de l'annonce s'appliquera de nouveau.",
    ownUnits: "Ces unités ont aussi leurs propres messages : {names}. Modifiez-les depuis chaque unité.",
    replaceHint: "Même nom qu'un message de l'annonce : celui-ci partira à sa place pour cette unité.",
  },
  clone: {
    button: "Cloner",
    rowAction: "Cloner vers un autre établissement ou une autre unité",
    titleAll: "Cloner vers d'autres établissements ou unités",
    bring: "Importer",
    bringTitle: "Importer les messages d'un autre établissement ou d'une autre unité",
    bringNoun: "ses messages programmés",
    titleOne: "Cloner « {name} »",
    subtitle: "Le texte, les canaux, les filtres et les fichiers sont copiés. Un message du même nom sur place est mis à jour ; les autres ne changent pas. Les messages actifs commenceront à partir à l'heure locale de chaque établissement.",
    nounAll: "le message programmé | les {n} messages programmés",
    nounOne: "le message « {name} »",
    done: "Copié vers {n} hébergement : {nuevos} nouveaux et {actualizados} mis à jour. | Copié vers {n} hébergements : {nuevos} nouveaux et {actualizados} mis à jour.",
    skipped: {
      limite: "{names} : le maximum de messages est atteint, « {msgs} » n'a pas été ajouté.",
      archivo: "{names} : un fichier de « {msgs} » est manquant. Importez-le à nouveau ici, puis clonez encore.",
      error: "{names} : impossible de copier « {msgs} ».",
    },
  },
  timeline: {
    booked: "Réservation confirmée",
    bookedHint: "S'il réserve une fois le moment passé, ce message n'est pas envoyé.",
    checkin: "Jour d'arrivée",
    checkout: "Jour de départ",
    use: "Utiliser",
    add: "+ Ajouter un message ici",
    offset: {
      sameDay: "Ce jour-là",
      before: "{n} jour avant | {n} jours avant",
      afterCheckin: "{n} jour après | {n} jours après",
      beforeCheckout: "{n} jour avant le départ | {n} jours avant le départ",
      after: "{n} jour après | {n} jours après",
    },
  },
  presets: {
    week: { name: "Plus qu'une semaine", text: "Bonjour {nombre}, votre séjour à {alojamiento} approche. Nous vous attendons le {entrada}. Si vous avez besoin de quoi que ce soit avant votre arrivée, écrivez-nous." },
    three: { name: "Préparez votre arrivée", text: "Bonjour {nombre}, dans 3 jours nous vous accueillons à {alojamiento}. L'arrivée est possible à partir de {hora_entrada}. Retrouvez ici toutes les informations de votre séjour : {enlace_portal}" },
    arrival: { name: "C'est aujourd'hui votre arrivée", text: "Bonjour {nombre}, nous vous attendons aujourd'hui à {alojamiento} à partir de {hora_entrada}. Bon voyage !" },
    firstNight: { name: "Première nuit", text: "Bonjour {nombre}, nous espérons que vous êtes bien installé à {alojamiento}. Tout va bien ? Si vous avez besoin de quoi que ce soit, répondez à ce message." },
    lastDay: { name: "Jour du départ", text: "Bonjour {nombre}, votre séjour à {alojamiento} se termine aujourd'hui. Pensez que le départ se fait avant {hora_salida}. Merci d'avoir séjourné chez nous." },
    after: { name: "Merci de votre visite", text: "Bonjour {nombre}, merci pour votre séjour à {alojamiento}. Nous espérons vous revoir très bientôt." },
  },
  row: {
    files: "{n} fichier | {n} fichiers",
    sent: "{n} envoyé | {n} envoyés",
    queued: "{n} en attente",
    failed: "{n} non envoyés",
    duplicate: "Dupliquer",
    delete: "Supprimer",
    confirmDelete: "Supprimer ce message ?",
    yesDelete: "Oui, supprimer",
    copyOf: "Copie de {name}",
  },
  upcoming: {
    arrives: "Arrive le {fecha}",
    leaves: "Part le {fecha}",
    note: "Ce qui partira dans les 30 prochains jours avec les réservations d'aujourd'hui. Barré : cette réservation ne peut pas être jointe par ce canal.",
    empty: "Aucun envoi prévu dans les 30 prochains jours.",
    when: "Quand",
    guest: "Voyageur",
    message: "Message",
    channels: "Canaux",
    needsCheckin: "Uniquement s'il termine le check-in",
    noReach: "Aucune donnée pour ce canal",
  },
  history: {
    empty: "Aucun message n'a encore été envoyé.",
    when: "Date",
    result: "Résultat",
    prev: "Précédent",
    next: "Suivant",
  },
  vars: {
    nombre: "Prénom",
    alojamiento: "Hébergement",
    entrada: "Date d'arrivée",
    salida: "Date de départ",
    hora_entrada: "Heure d'arrivée",
    hora_salida: "Heure de départ",
    codigo: "Code de réservation",
    enlace_portal: "Lien du portail",
    enlace_tienda: "Lien de la boutique",
  },
  form: {
    newTitle: "Nouveau message",
    editTitle: "Modifier le message",
    name: "Nom interne",
    namePh: "Ex. : Préparez votre arrivée",
    when: "Quand il est envoyé",
    type: { antes: "Avant le", dia: "Le jour même du", despues: "Après le" },
    days: "Jours",
    reference: "Référence",
    theDayOf: "Jour du",
    anchor: { entrada: "Check-in", salida: "Check-out" },
    time: "Heure",
    timeIn: "heure de {zone}",
    timeEach: "à l'heure locale de chaque hébergement : {zones}",
    noZone: "{names} : sans pays défini, nous ne connaissons pas son heure et les messages n'y partiront pas. Indiquez-le dans la localisation de l'hébergement.",
    localTime: "heure de l'hébergement",
    duringHint: "Si le séjour est plus court et que le voyageur n'est plus là ce jour-là, il n'est pas envoyé.",
    channels: "Par quel canal",
    channelShort: { email: "E-mail personnel uniquement", whatsapp: "Modèle après 24 h", ota: "Chat de la réservation" },
    previewShort: "Aperçu",
    previewFrom: "Message de",
    channelHint: {
      email: "Uniquement pour les réservations avec e-mail personnel. L'e-mail fourni par les OTA est un alias : rien n'y arrive.",
      whatsapp: "Si plus de 24 h se sont écoulées ou s'il n'y a pas de conversation, nous envoyons le modèle de contact et le message arrive une fois accepté. Avec un faux numéro, rien n'est envoyé.",
      ota: "Via le chat de l'OTA, uniquement pour les réservations de ce canal. Les fichiers sont envoyés sous forme de lien.",
    },
    bookings: "Pour quelles réservations",
    onlyCheckin: "Uniquement s'il a déjà terminé le check-in",
    message: "Message",
    messagePh: "Rédigez le message que recevra le voyageur",
    translate: "Traduire dans les autres langues",
    translating: "Traduction en cours…",
    translated: "Traduit dans les autres langues.",
    translatePartial: "{n} langues n'ont pas pu être traduites. Vérifiez-les.",
    storeHint: "La boutique interne nécessite un check-in terminé ; d'ici là, le lien mène au portail du voyageur, depuis lequel on y accède. Avec une boutique externe, il y mène directement.",
    fallbackHint: "Il est envoyé dans la langue du voyageur. Si cette langue n'est pas rédigée, il part en espagnol ou dans la première disponible.",
    subject: "Objet de l'e-mail (facultatif)",
    subjectPh: "Si vide : Message de votre hébergement",
    files: "Photos, vidéos et documents",
    addFile: "Ajouter un fichier",
    uploading: "Téléversement…",
    filesHint: "Photos JPG ou PNG jusqu'à {img} Mo, PDF jusqu'à {pdf} Mo, XML jusqu'à {xml} Mo et vidéos MP4 ou 3GP (H.264) jusqu'à {video} Mo. WhatsApp n'accepte pas le XML comme fichier : il y est envoyé sous forme de lien. Par e-mail, il est joint.",
    fileTooBig: "« {name} » dépasse la limite de {max} Mo.",
    uploadError: "Impossible de téléverser le fichier.",
    active: "Actif",
    inactive: "Désactivé",
    save: "Enregistrer",
    saving: "Enregistrement…",
    saved: "Message enregistré.",
    saveError: "Impossible d'enregistrer. Réessayez.",
    errName: "Donnez un nom au message.",
    errChannels: "Choisissez au moins un canal d'envoi.",
    errTime: "Indiquez l'heure d'envoi.",
    errText: "Rédigez le message dans au moins une langue.",
    preview: "Aperçu avec des données d'exemple",
    previewEmpty: "Le message s'affichera ici.",
  },
};
